import produce from 'immer';
import _ from 'lodash';

// Utils
import {configs} from './constant';

export const actionTypes = {
	SET_STATUS_GO_TO_OTHER_ACTION: 'SET_STATUS_GO_TO_OTHER_ACTION',
	SET_ARRAY_ACTION_GO_TO_OTHER_ACTION: 'SET_ARRAY_ACTION_GO_TO_OTHER_ACTION',
	SET_REF_OBJECT_ID_GO_TO_OTHER_ACTION: 'SET_REF_OBJECT_ID_GO_TO_OTHER_ACTION',
	ADD_NODE_GO_TO_OTHER_ACTION: 'ADD_NODE_GO_TO_OTHER_ACTION',
	SET_NODE_BRANCH: 'SET_NODE_BRANCH',
	SET_NODE_TREES: 'SET_NODE_TREES',
	SET_FLATTEN_NODES: 'SET_FLATTEN_NODES',
	SET_FLATTEN_NODES_WITH_REMOVE_NODE: 'SET_FLATTEN_NODES_WITH_REMOVE_ACTION',
	SET_FLATTEN_NODES_WITH_ADD_NODE: 'SET_FLATTEN_NODES_WITH_ADD_NODE',
	CANCEL_CHANGE_NODE_GO_TO_OTHER_ACTION: 'CANCEL_CHANGE_NODE_GO_TO_OTHER_ACTION',
	CREATE_NODE: 'CREATE_NODE',
	CREATE_NODE_BRANCH: 'CREATE_NODE_BRANCH',
	REMOVE_NODE: 'REMOVE_NODE',
	REMOVE_NODE_BRANCH: 'REMOVE_NODE_BRANCH'
};

export const initialState = {
	nodeBranch: [],
	nodeTrees: [],
	flattenNodes: [],
	disabledNodes: [],
	arrActionGoToOtherAction: [],
	statusGoToOtherAction: {
		isSelect: false,
		nodeIdToCome: null,
		nodeIdToGo: null,
		parentId: null
	}
};

export const reducer = (state, action) => {
	try {
		switch (action.type) {
			case actionTypes.ADD_NODE_GO_TO_OTHER_ACTION: {
				if (action.payload && action.payload.param) {
					const {param} = action.payload;

					return produce(state, (draftState) => {
						let parentId = null;

						let result = [];
						const cloneDeepData = _.cloneDeep(state.flattenNodes);

						if (cloneDeepData.length > 1) {
							result = cloneDeepData.map((node) => {
								if (node.parentId === param.parentId) {
									node.parentId = param.nodeId;
								}
								node.active = false;
								return {...node};
							});

							result = [...result, {...param}];
						}

						draftState.flattenNodes = result;

						const nodes = state.flattenNodes.reduce((objNode, currentNode) => {
							return {
								...objNode,
								[currentNode.nodeId]: currentNode
							};
						}, {});

						const disabledNodes = (nodes, nodeId, disabled) => {
							disabled = [...disabled, nodeId];
							if (nodes[nodeId] && nodes[nodeId].parentId) {
								disabled = disabledNodes(nodes, nodes[nodeId].parentId, disabled);
							}

							return disabled;
						};

						let disabled = [];

						disabled = disabledNodes(nodes, param.parentId, []);

						Object.values(nodes).some((item) => {
							if (item.nodeType === configs.NODE_TYPE_GO_TO_OTHER_ACTION) {
								disabled = [...disabled, item.nodeId];
								return true;
							}
						});

						draftState.statusGoToOtherAction.isSelect = true;
						draftState.statusGoToOtherAction.nodeIdToGo = param.nodeId;
						draftState.statusGoToOtherAction.parentId = parentId;
						draftState.disabledNodes = disabled;
					});
				}

				return state;
			}
			case actionTypes.SET_REF_OBJECT_ID_GO_TO_OTHER_ACTION: {
				if (action.payload.nodeId && action.payload.objectRefId) {
					const nodeIndex = state.flattenNodes.findIndex((node) => node.nodeId === action.payload.nodeId);

					return produce(state, (draftState) => {
						draftState.flattenNodes[nodeIndex].objectRefId = action.payload.objectRefId;
					});
				}
				return state;
			}
			case actionTypes.CANCEL_CHANGE_NODE_GO_TO_OTHER_ACTION: {
				if (state.statusGoToOtherAction.nodeIdToGo) {
					return produce(state, (draftState) => {
						draftState.statusGoToOtherAction.isSelect = false;
						draftState.statusGoToOtherAction.nodeIdToGo = null;
						draftState.statusGoToOtherAction.parentId = null;
						draftState.disabledNodes = [];
					});
				}
				return state;
			}
			case actionTypes.SET_STATUS_GO_TO_OTHER_ACTION:
				return {...state, count1: state.count1 + 1};
			case actionTypes.SET_ARRAY_ACTION_GO_TO_OTHER_ACTION:
				return {...state, arrActionGoToOtherAction: action.payload.arrActionGoToOtherAction};
			case actionTypes.SET_NODE_BRANCH:
				return {...state, nodeBranch: action.payload.nodeBranch};
			case actionTypes.SET_NODE_TREES:
				return {...state, nodeTrees: action.payload.nodeTrees};
			case actionTypes.SET_FLATTEN_NODES:
				return {...state, flattenNodes: action.payload.flattenNodes};
			default:
				return state;
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);

		return state;
	}
};

